module.exports = __webpack_public_path__ + "assets/img/Pioneer_Rochat_cover.12a84468-ps.jpg";